<template>
  <div class="order_info">
    <img src="@/assets/images/home/personal/user_logo2.png" alt="" />
    <div class="info">
      <div class="item">
        <span class="label">订单号</span>
        <p class="value">{{ out_trade_no }}</p>
      </div>
    </div>
    <div class="botton_box">
      <van-button plain type="primary" @click="goUrl()">返回首页</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderInfo",
  data() {
    return {
      /** 商户订单号 */
      out_trade_no: "",
    };
  },
  mounted() {
    let mchData = {
      action: "onIframeReady",
      displayStyle: "SHOW_CUSTOM_PAGE",
    };
    let postData = JSON.stringify(mchData);
    parent.postMessage(postData, "https://payapp.weixin.qq.com");
    if (document.querySelector("html").style.fontSize == "0px")
      document.querySelector("html").style.fontSize = "36px";
  },
  created() {
    let query = this.$route.query;
    this.out_trade_no = query.out_trade_no;
  },
  methods: {
    goUrl() {
      /** jumpOutUrl 跳转的页面 */
      var mchData = {
        action: "jumpOut",
        jumpOutUrl: "http://ticket.wzkjg.cn/wx_uat/",
      };
      var pData = JSON.stringify(mchData);
      parent.postMessage(pData, "https://payapp.weixin.qq.com");
    },
  },
};
</script>

<style lang="scss" scoped>
.order_info {
  display: flex;
  flex-direction: column;
  align-items: center;
  > img {
    width: 80px;
    height: 80px;
    margin: 20px 0;
  }
  .info {
    font-size: 16px;
    display: flex;
    flex-direction: column;
    width: calc(100% - 80px);
    padding: 10px 40px;
    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .label {
        width: 100px;
      }
      .value {
        width: 100%;
        text-align: right;
      }
    }
  }
  .botton_box {
    .van-button {
      border-radius: 10px;
    }
  }
}
</style>
